import { render } from "./WorkflowsOld.vue?vue&type=template&id=33087170&scoped=true&lang=pug"
import script from "./Workflows.js?vue&type=script&lang=js&external"
export * from "./Workflows.js?vue&type=script&lang=js&external"

import "./WorkflowsOld.vue?vue&type=style&index=0&id=33087170&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33087170"]])

export default __exports__